module.exports = __webpack_public_path__ + "static/media/Resume-Caleb Ruto.24cd1665.docx";